import favouritesReducer from "../reducers/FavouritesReducer";

export const selectFavourites = favouritesReducer.selectState;
